import { Routes } from '@angular/router';
import { ContentPageComponent } from './containers/content-page/content-page.component';
import { ContentPageDetailGuard } from './guards';
import { ContentPageMetaGuard } from './guards/content-page-meta.guard';

import * as fromStore from './store';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

export const routes: Routes = [
  {
    path: ':pageId/:target',
    component: ContentPageComponent,
    canActivate: [ContentPageDetailGuard, ContentPageMetaGuard],
    providers: [
      provideState(fromStore.featureKey, fromStore.reducers, {
        metaReducers: fromStore.metaReducers,
      }),
      provideEffects(fromStore.effects),
    ],
  },
];
